export const defaultNotificationParams = {
  position: "bottom-center",
  type: "error",
  removeAfter: 3000,
};
